module.exports = __webpack_public_path__ + "static/media/fe.1c9112a0.svg";